import { CmsApiSignUpBlockData } from 'modules/cms/api/types/blocks/CmsApiSignUpBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsSignUpBlock } from './CmsSignUpBlock';

export const CmsSignUpBlockMapping: CmsBlockMapping<CmsApiSignUpBlockData> = {
  invariant: [],
  width: CmsMappedBlockWidth.FULL,
  Component: CmsSignUpBlock,
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type '(props: Cms... Remove this comment to see the full error message
  AmpComponent: null,
};
